import { render, staticRenderFns } from "./comprador.vue?vue&type=template&id=a8ee13ae"
import script from "./comprador.vue?vue&type=script&lang=js"
export * from "./comprador.vue?vue&type=script&lang=js"
import style0 from "./comprador.vue?vue&type=style&index=0&id=a8ee13ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports